import type { HexColor } from "./hex-color/hex-color";
import type { RGBA } from "./rgba-color/rgba-color";

const parseHexRegEx =
    /^#([A-Fa-f0-9]{8}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{3}|[A-Fa-f0-9]{2})$/i;
const parseCssHex = (hex: HexColor): RGBA => {
    const parseResult = parseHexRegEx.exec(hex)?.[1];
    parseHexRegEx.lastIndex = 0;
    if (!parseResult) throw new Error(`Bad hex value: ${hex}`);

    const parts = (() => {
        if (parseResult.length === 2) {
            return {
                red: parseResult[0] + parseResult[1],
                green: parseResult[0] + parseResult[1],
                blue: parseResult[0] + parseResult[1],
                alpha: undefined,
            };
        }
        if (parseResult.length === 3) {
            return {
                red: parseResult[0] + parseResult[0],
                green: parseResult[1] + parseResult[1],
                blue: parseResult[2] + parseResult[2],
                alpha: undefined,
            };
        }
        if (parseResult.length === 6) {
            return {
                red: parseResult.slice(0, 2),
                green: parseResult.slice(2, 4),
                blue: parseResult.slice(4, 6),
                alpha: undefined,
            };
        }
        if (parseResult.length === 8) {
            return {
                red: parseResult.slice(0, 2),
                green: parseResult.slice(2, 4),
                blue: parseResult.slice(4, 6),
                alpha: parseResult.slice(6, 8),
            };
        }
        throw new Error("Bad hex value: " + hex);
    })();

    const red = parseInt(parts.red, 16) / 255;
    const green = parseInt(parts.green, 16) / 255;
    const blue = parseInt(parts.blue, 16) / 255;
    const alpha =
        typeof parts.alpha !== "undefined"
            ? parseInt(parts.alpha, 16) / 255
            : 1;

    return { red, green, blue, alpha };
};
export { parseCssHex };
